import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'ft-header',
    templateUrl: './header.component.html',
    standalone: false
})
export class HeaderComponent implements OnInit {
    @Input() backgroundImageUrl: string | null;
    @Input() blur = false;
    @Input() matte = true;
    @Input() inverse = false;
    @Input() fadeOut: 'dark' | 'light';
    @Input() modifierClass: string | null;
    @Input() contentModifierClass: string | null;

    constructor() {
    }

    ngOnInit() {
    }

}
